import { Component, OnInit } from '@angular/core';
import { BusinessInfo } from '../../../classes/business-info';
import { BusinessinfoService } from '../../../services/businessinfo.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../../shared/services/user.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'business-info-page',
  templateUrl: './business-info-page.component.html',
  styleUrls: ['./business-info-page.component.scss']
})
export class BusinessInfoPageComponent implements OnInit {

  businessInfo: BusinessInfo = <BusinessInfo>{};
  sub: any;
  orgId: number;
  error: string;
  isAdmin: boolean;
  company: any;
  steps: any;
  incomplete: boolean;
  state: any;
  adding: boolean = false;
  nameFocus: boolean = false;
  numFocus: boolean = false;
  addr1Focus: boolean = false;
  addr2Focus: boolean = false;
  cityFocus: boolean = false;
  provFocus: boolean = false;
  postalFocus: boolean = false;
  openNumberPopup: boolean = false;
  openNamePopup: boolean = false;
  openProvPopup: boolean = false;

  constructor(
    private BusinessinfoService: BusinessinfoService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private CompanyService: CompanyService
  ) { }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.getCompanyInfo();
      this.getComplete();
    });
    this.titleService.setTitle('Business Information');
    this.UserService.getUserInfo()
      .subscribe(user => {        
        let u: any = JSON.parse(user.user);
        console.log(user, u.admin)
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getComplete() {
    this.CompanyService.getCompany(this.orgId)
      .subscribe(company => {
        this.company = JSON.parse(company.organization);
        this.steps = JSON.parse(company.steps);
        this.incomplete = this.steps.slice(0, 2).some(s => {
          console.log(s)
          return !s[2];
        })
        if (this.incomplete) {
          this.router.navigate(['/onboarding/department/', this.orgId])
        }
        this.state = JSON.parse(company.state);
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getCompanyInfo() {
    this.BusinessinfoService.getBusinessInfo(this.orgId)
      .subscribe(company => {
        this.businessInfo = JSON.parse(company.company_informations || '[]')[0] || <BusinessInfo>{};
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  submit(businessInfoForm: NgForm) {
    this.error = '';
    this.adding = true;
    if (businessInfoForm.invalid) {
      return;
    }

    if (this.businessInfo.id) {
      this.BusinessinfoService.editBusinessInfo(this.orgId, this.businessInfo.id, this.businessInfo)
        .subscribe(company => {
          this.adding = false;
          if(!this.isAdmin) window.analytics.track("Self-Signup Business Info Added", {OrgId: this.orgId});
          this.router.navigate(['/onboarding/remittanceinfo', this.orgId]);
        }, err => {
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
          else {
            this.error = 'Invalid business number';
            if(!this.isAdmin) window.analytics.track("Self-Signup Business Info Addition Failed", {OrgId: this.orgId, reason: this.error});
          }

        })
    }
    else {
      this.BusinessinfoService.addBusinessInfo(this.orgId, this.businessInfo)
        .subscribe(company => {
          this.adding = false;
          if(!this.isAdmin) window.analytics.track("Self-Signup Business Info Added", {OrgId: this.orgId});
          this.router.navigate(['/onboarding/remittanceinfo', this.orgId]);
        }, err => {
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
          else {
            this.error = 'Invalid business number';
            if(!this.isAdmin) window.analytics.track("Self-Signup Business Info Addition Failed", {OrgId: this.orgId, reason: this.error});
          }

        })

    }
  }

  showError(ev: string) {
    this.error = ev;
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openNumberPopup = false;
      this.openNamePopup = false;
      this.openProvPopup = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/company-setup/business-info-page/business-info-page.component.ts